import { render, staticRenderFns } from "./Abatedor.vue?vue&type=template&id=6405f3ec&"
import script from "./Abatedor.vue?vue&type=script&lang=js&"
export * from "./Abatedor.vue?vue&type=script&lang=js&"
import style0 from "./Abatedor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports